// extracted by mini-css-extract-plugin
module.exports = {"jobCard-matchingBalloon":"jobCard-matchingBalloon","jobCard-matchingBalloon__message":"jobCard-matchingBalloon__message"};